import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import FavMealDetailsQuery from './FavMealDetailsQuery';

const FavMealDetailsConnectorApollo = ({ children, mealId }) => {
  const { loading, error, data, refetch } = useQuery(FavMealDetailsQuery, {
    variables: { mealId },
  });

  const result = {
    loading,
    error,
    refetch,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.favMeal = data.me.favoriteMeal;
    result.diabeticDietConfig = data.diabetes.userDiabetes?.diabeticDietConfig || {};
    result.lastAvailableDay =
      data.me.diet.availableDays.length > 0 ? data.me.diet.availableDays.slice(-1)[0].date : '0';
  }

  return children(result);
};

FavMealDetailsConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
  mealId: PropTypes.number.isRequired,
};

export default FavMealDetailsConnectorApollo;
